import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { RootState } from '../../../reducers';
import { closeConfirmDeleteTeamModal, deleteSelectedTeam } from '../../../store/careTeams.slice';

const ConfirmDeleteTeamModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const { isConfirmDeleteTeamModalOpen, selectedTeam } = useSelector((state: RootState) => state.careTeams);

    const handleClose = () => {
        dispatch(closeConfirmDeleteTeamModal());
    };

    const handleDelete = async () => {
        if (selectedTeam) {
            try {
                dispatch(deleteSelectedTeam());
                dispatch(closeConfirmDeleteTeamModal());
            } catch (error) {
                console.error('Error deleting team:', error);
            }
        }
    };

    return (
        <Dialog open={isConfirmDeleteTeamModalOpen} onClose={handleClose}>
            <DialogTitle>
                Confirm Delete <strong>{selectedTeam?.Name}</strong>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete the team?
                    <br />
                    <strong>This will remove all provider and member assignments from the team. This action cannot be undone.</strong>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" variant="contained">
                    Cancel
                </Button>
                <Button onClick={handleDelete} color="error" variant="contained">
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDeleteTeamModal;
